import React from "react";
import { Link } from "react-router-dom";
import paalanaLogo from "../../../assets/Logo/paalana-logo.svg";

export const Logo: React.FC = () => {
  return (
    <Link
      to="/"
      className="flex items-center lg:hover:opacity-80 transition-opacity z-10 flex-shrink-0"
    >
      <div className="relative h-11 w-28 sm:h-11 sm:w-28 md:h-12 md:w-32 lg:h-16 lg:w-56 xl:h-16 xl:w-64 overflow-hidden flex items-center justify-center">
        <img
          src={paalanaLogo}
          alt="Paalana Logo"
          className="h-full w-full object-contain scale-[1.58] sm:scale-[1.5] md:scale-[1.55] lg:scale-[1.95] xl:scale-[2.05] transition-transform duration-300 lg:hover:scale-[2.12]"
          style={{
            objectFit: "contain",
          }}
        />
      </div>
    </Link>
  );
};

